exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-text[data-v-c2526cea] {\n\tcolor: #06263e;\n\tfont-size: 1rem;\n\tfont-weight: 600;\n\tletter-spacing: 0.07rem;\n}\n", ""]);

// exports
